var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / _Other / Circle / Success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-_Other-/-Circle-/-Success",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z M26.0618813,9.61871843 C25.7201725,9.27700968 25.1661532,9.27700968 24.8244444,9.61871843 L24.8244444,9.61871843 L13.9644952,20.4774369 L9.4561553,15.9687184 C9.11444655,15.6270097 8.56042719,15.6270097 8.21857775,15.9688591 C7.87702442,16.3105679 7.87715041,16.8644612 8.21885915,17.2060146 L8.21885915,17.2060146 L13.2581409,22.2430045 C13.2577754,22.2437361 13.2579585,22.243919 13.2581416,22.2441017 L13.2581416,22.2441017 L13.3524321,22.3271955 C13.7450263,22.6318235 14.3121902,22.6034858 14.6718053,22.2421343 L14.6718053,22.2421343 L15.1524952,21.7604369 L15.1547592,21.7632774 L26.0618813,10.8561553 C26.4035901,10.5144465 26.4035901,9.96042719 26.0618813,9.61871843 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.c16fe0fb3bc4ffa5d7a4f8b5cf775ab7.svg";
export { ForwardRef as ReactComponent };